import PropTypes from 'prop-types';
import * as S from './ModalBase.styled';

const ModalBase = ({ isBigModal, children }) => {
  return (
    <S.Overlay isBigModal={isBigModal} className='modal_base'>
      <S.ModalsBox>{children}</S.ModalsBox>
    </S.Overlay>
  );
};

ModalBase.propTypes = {
  isBigModal: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default ModalBase;
